/**
 * @author Hiroki Moto
 * @description https://marvelapp.com/43fgc52/screen/54134918
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Row, Col } from 'react-bootstrap';
import { equals, isEmpty, isNil, values } from 'ramda';
import { toast } from 'react-toastify';
import Accordion from '@components/@core/Accordion';
import Button from '@components/@core/AnimatedButton';
import Dropdown from '@components/@core/Dropdown';
import Filter from '@components/@core/Filter';
import Input from '@components/@core/Input';
import { RecurringType } from '~/services/config';

const FREQUENCY = values(RecurringType);

class Add extends Component {
    state = {
        title: '',
        description: '',
        selected: { author: [], department: [], competency: [], category: [], frequency: null },
    };

    handleSelectFrequency = (e) => {
        const schedule = e[0];
        const { selected } = this.state;
        selected.frequency = schedule.name;
        this.setState({ selected });
    };

    handleSelectTags = (key) => (tags) => {
        const { selected } = this.state;
        if (!equals(selected[key], tags)) {
            selected[key] = tags;
            this.setState({ selected });
        }
    };

    handleSubmit = (published) => () => {
        const { title, description, selected } = this.state;
        if (isEmpty(title) || isEmpty(selected.author) || isNil(selected.frequency)) {
            toast.error('Please enter title, author and frequency properly.', {
                position: toast.POSITION.TOP_RIGHT,
                pauseOnFocusLoss: false,
                hideProgressBar: true,
            });
            return;
        }
        const data = {
            template: {
                card_type_id: 8,
                name: title,
                author_id: selected.author[0],
                access_type: 1,
                published,
                data: {
                    description,
                    author: selected.author,
                    category: selected.category,
                    competency: selected.competency,
                    department: selected.department,
                    type: 'recurring',
                    schedule_end: 'never',
                    schedule_increment: 1,
                    schedule_interval: selected.frequency,
                    schedule_options: { days: [moment().format('ddd')] },
                    schedule_start: new Date().toISOString(),
                    schedule_start_timestamp: moment().unix(),
                },
            },
        };
        const payload = { type: 'habits', data };
        this.props.onCreate(payload);
    };

    render() {
        const { title, description } = this.state;
        const { authors, departments, competencies, categories } = this.props;
        const disabled = !title || !description;

        return (
            <>
                <Filter back="all habits" />
                <div className="lib-todo-habit">
                    <div className="habit-detail">
                        <div className="d-flex py-2">
                            <p className="dsl-b18 bold mb-0">Add Habit</p>
                        </div>
                        <Input
                            className="input-field"
                            title="Title"
                            dataCy="title"
                            type="text"
                            direction="vertical"
                            value={title}
                            placeholder="Type here..."
                            onChange={(e) => this.setState({ title: e })}
                        />
                        <Input
                            title="Description"
                            dataCy="description"
                            className="input-field input-textarea"
                            type="text"
                            as="textarea"
                            rows="2"
                            direction="vertical"
                            value={description}
                            placeholder="Type here..."
                            onChange={(e) => this.setState({ description: e })}
                        />
                        <Dropdown
                            title="Frequency"
                            dataCy="frequency"
                            direction="vertical"
                            width="fit-content"
                            data={FREQUENCY}
                            getValue={(e) => e.label}
                            returnBy="data"
                            onChange={this.handleSelectFrequency}
                        />
                        <Accordion className="settings-habit mt-3" icon="fas fa-gear" expanded>
                            <Row className="mt-1">
                                <Col xs={12} sm={6} className="my-3">
                                    <Dropdown
                                        className="dropdown-field author"
                                        title="Author"
                                        direction="vertical"
                                        dataCy="author"
                                        width="fit-content"
                                        data={authors}
                                        getValue={(e) => e.name}
                                        onChange={this.handleSelectTags('author')}
                                    />
                                </Col>
                                <Col xs={12} sm={6} className="my-3">
                                    <Dropdown
                                        multi
                                        className="dropdown-field habit"
                                        title="Categories"
                                        direction="vertical"
                                        dataCy="categories"
                                        width="fit-content"
                                        data={categories}
                                        getValue={(e) => e.name}
                                        placeholder="Select multiple"
                                        onChange={this.handleSelectTags('category')}
                                    />
                                </Col>
                                <Col xs={12} sm={6} className="my-3">
                                    <Dropdown
                                        multi
                                        className="dropdown-field habit"
                                        title="Competencies"
                                        direction="vertical"
                                        dataCy="competencies"
                                        width="fit-content"
                                        data={competencies}
                                        getValue={(e) => e.name}
                                        placeholder="Select multiple"
                                        onChange={this.handleSelectTags('competency')}
                                    />
                                </Col>
                                <Col xs={12} sm={6} className="my-3">
                                    <Dropdown
                                        multi
                                        className="dropdown-field dropdown-list department"
                                        title="Departments"
                                        direction="vertical"
                                        dataCy="departments"
                                        width="fit-content"
                                        data={departments}
                                        getValue={(e) => e.name}
                                        placeholder="Select multiple"
                                        onChange={this.handleSelectTags('department')}
                                    />
                                </Col>
                            </Row>
                        </Accordion>
                        <div className="mt-4 d-flex jc-end">
                            <Button className="btn-save me-3" name="Draft" disabled={disabled} type="low" onClick={this.handleSubmit(0)} />
                            <Button className="btn-save" name="Publish" disabled={disabled} onClick={this.handleSubmit(1)} />
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

Add.propTypes = {
    authors: PropTypes.array.isRequired,
    departments: PropTypes.array.isRequired,
    competencies: PropTypes.array.isRequired,
    categories: PropTypes.array.isRequired,
    history: PropTypes.any.isRequired,
    onCreate: PropTypes.func.isRequired,
};

Add.defaultProps = {
    authors: [],
    departments: [],
    competencies: [],
    categories: [],
    history: [],
    onCreate: () => {},
};

export default Add;
